// Packages
import React from "react";

// Controllers
import useControllers from "../../../../controllers";

// Components
import useComponents from "../../../components";

const RolesEdit = () => {
  const { useScreenHooks } = useControllers();
  const { useRoles } = useScreenHooks();
  const { useRolesEdit } = useRoles();
  const {
    control,
    handleSubmit,
    onSubmit,
    showModal,
    handleCloseModal,
    groupedPermissions,
  } = useRolesEdit();

  const {
    ContentWrappers,
    useButtons,
    TextFieldControlled,
    Typography,
    useModals,
    HierarchicalPermissionsGroup,
    FormLabel,
  } = useComponents();

  const { DefaultButton } = useButtons();
  const { DefaultModal } = useModals();

  return (
    <div className="bg-white px-16 pt-10 pb-12 mx-24 rounded-lg">
      <form onSubmit={handleSubmit(onSubmit)}>
        <ContentWrappers
          gridColums={["1fr"]}
          gap={{
            row: "0px",
            column: "4%",
          }}
        >
          <TextFieldControlled
            type="text"
            id="abi-role-name"
            name="name"
            control={control}
            label="Nombre del Rol"
            placeholder="Nombre del Rol"
          />
        </ContentWrappers>
        <FormLabel label="Permisos" />
        <HierarchicalPermissionsGroup
          groupedPermissions={groupedPermissions}
          control={control}
          name="permissions"
        />
        <div className="text-center mt-8">
          <DefaultButton color="secondary" type="submit">
            Guardar
          </DefaultButton>
        </div>
      </form>
      <DefaultModal isOpen={showModal}>
        <div className="flex items-center flex-col space-y-8">
          <Typography variant="body2">Cambios realizados con éxito</Typography>
          <DefaultButton color="success" onClick={handleCloseModal}>
            Aceptar
          </DefaultButton>
        </div>
      </DefaultModal>
    </div>
  );
};

export default RolesEdit;
